import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/merchants/inbounds/reject_returns'

const MerchantInboundRejectReturnApiV2 = {
  /**
   * Get list of `Merchant Inbound Reject Returns`
   * @param {object} tableState - ReactTable final state
   */
  get: async ({ tableState }) => {
    const params = QueryParamsUtil.format(tableState)
    const path   = API_PATH

    const response = await axios.get(path, { params })
    return response
  },

  /**
   * Show Merchant Inbound Reject Return by specific id
   * Inovke `GET api/v2/admins//merchant/inbounds/reject_returns/:id`
   * @param {number} id Merchant Inbound's ID
   */
  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },

  /**
   * Get list of `Merchant Inbound Reject Returns`
   * @param {object} tableState - ReactTable final state
   */
  getItems: async ({ tableState, id }) => {
    const params = QueryParamsUtil.format(tableState)
    const path   = `${API_PATH}/${id}/items`

    const response = await axios.get(path, { params })
    return response
  },

  /**
   * Invoke `PATCH api/v2/admins/merchants/inbounds/reject_returns/:id`
   */
  update: async (id, update_values) => {
    const path     = `${API_PATH}/${id}`
    const body     = {
      reject_return: update_values
    }
    const response = axios.patch(path, body)
    return response
  },

  /**
   * Invoke `PATCH api/v2/admins/merchants/inbounds/reject_returns/:id/ship`
   */
  ship: async (id) => {
    const path     = `${API_PATH}/${id}/ship`
    const response = axios.patch(path)
    return response
  }

}

export default MerchantInboundRejectReturnApiV2
